import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ProductApp } from "@/app/router";
import { AppClerkProvider } from "@/auth";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import "@/styles/main.scss";

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root element #root not found");
}

const html = document.documentElement;
if (html.classList.contains("spa-route")) {
  rootEl.replaceChildren();
  html.classList.remove("spa-route");
}

createRoot(rootEl).render(
  <StrictMode>
    <ErrorBoundary>
      <AppClerkProvider>
        <ProductApp />
      </AppClerkProvider>
    </ErrorBoundary>
  </StrictMode>,
);
